import React from 'react';
import { flatten } from 'lodash';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { css, cx } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';

const styles = css`
  display: inline-block;
`;

const getHomeString = home => `Home: ${home.address.streetAddress} ${home.address.addressLocality}, ${home.address.addressRegion}, ${home.address.postalCode}`;
const getCommunityString = community => `Community: ${community.name} - ${community.address.addressLocality}, ${community.address.addressRegion}, ${community.address.postalCode}`;
const getPlanString = plan => `Plan: ${plan.name} in ${plan.community.name}`;
const getBlogpostString = post => `News: ${post.title}`;

// Add all plans in communities as results

class Search extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      search: '',
      results: [],
    };
  }

  componentDidMount() {
    if (this.props.searchIsFocusedOnLoad) {
      this.searchInput.focus();
    }
    document.addEventListener('click', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  handleSearchChange = event => {
    const { homes, communities, plans, blogposts } = this.props;

    const getResults = search => {
      const results = [];

      results.push(...(homes || [])
      .filter(home => getHomeString(home).toLowerCase().indexOf(search.toLowerCase()) !== -1));

      results.push(
        ...(communities || [])
          .filter(community => (
            getCommunityString(community)
            .toLowerCase()
            .indexOf(search.toLowerCase()) !== -1),
          ));

      const communitesById = communities
        .reduce((acc, com) => { acc[com._id] = com; return acc; }, {});
      const communityPlans = plans.reduce((acc, plan) => {
        plan.communities.forEach(planCom => {
          if (communitesById[planCom.community]) {
            acc.push({ ...plan, community: communitesById[planCom.community] });
          }
        });

        return acc;
      }, []);

      results.push(...flatten((communityPlans || []))
      .filter(plan => getPlanString(plan).toLowerCase().indexOf(search.toLowerCase()) !== -1));

      results.push(
        ...(blogposts || [])
          .filter(post =>
            getBlogpostString(post).toLowerCase().indexOf(search.toLowerCase()) !== -1,
          )
          .map(post => ({ ...post, type: 'blogpost' })),
        );

      if (event.key === 'Enter' || event.key === 'NumpadEnter') {
        if (results && results.length >= 1) {
          this.searchBoxRef.querySelector('a').click();
        }
      }

      return results;
    };

    this.setState({
      search: event.target.value,
      results: getResults(event.target.value),
    });
  }

  clearSearch = () => {
    this.setState({
      search: '',
      results: [],
    });

    this.props.onSelected();
  }

  handleClickOutside = event => {
    if (
      this.searchBoxRef
      && !this.searchBoxRef.isSameNode(event.target)
      && !this.searchBoxRef.contains(event.target)
    ) {
      this.clearSearch();
    }
  }

  render() {
    const { search, results, focus } = this.state;
    const { className } = this.props;
    return (
      <div className={cx(styles, className)}>
        <div className="Search_results" role="search" ref={node => { this.searchBoxRef = node; }}>
          <input ref={input => { this.searchInput = input; }} className={focus} type="text" placeholder="Search by City, Zip, Community or Plan" value={search} onChange={this.handleSearchChange} onKeyPress={this.handleSearchChange} />
          {
            !!search &&
            <ul className="Search_resultsList">
              {
                results.length === 0 &&
                <li className="Search_resultsNone">No results for &ldquo;{search}&rdquo;</li>
              }
              {
                results.length > 0 &&
                results.map(result => (
                  <li key={result._id}>
                    {
                      result.type === 'home' &&
                      <Link name="home-detail" home={result} onClick={this.clearSearch} className="Search_resultsLink">
                        {getHomeString(result)}
                      </Link>
                    }
                    {
                      result.type === 'community' &&
                      <Link name="community-detail" community={result} onClick={this.clearSearch} className="Search_resultsLink">
                        {getCommunityString(result)}
                      </Link>
                    }
                    {
                      result.type === 'plan' &&
                      <Link name="plan-detail" plan={result} community={result.community} onClick={this.clearSearch} className="Search_resultsLink">
                        {getPlanString(result)}
                      </Link>
                    }
                    {
                      result.type === 'blogpost' &&
                      <Link
                        name="blogpost-detail"
                        params={{
                          blogpostTitle: result.title,
                        }}
                        onClick={this.clearSearch}
                        className="Search_resultsLink"
                      >
                        {getBlogpostString(result)}
                      </Link>
                    }
                  </li>
                ))
              }
            </ul>
          }

        </div>
      </div>
    );
  }
}

Search.propTypes = {
  homes: PropTypes.arrayOf(PropTypes.object),
  communities: PropTypes.arrayOf(PropTypes.object),
  plans: PropTypes.arrayOf(PropTypes.object),
  blogposts: PropTypes.arrayOf(PropTypes.object),
  onSelected: PropTypes.func,
  className: PropTypes.string,
  searchIsFocusedOnLoad: PropTypes.bool,
};

Search.defaultProps = {
  homes: [],
  communities: [],
  plans: [],
  blogposts: [],
  onSelected: () => {},
  className: undefined,
  searchIsFocusedOnLoad: false,
};

export default withData({
  homes: 'all',
  plans: 'all',
  communities: 'all',
  blogposts: 'all',
})(Search);



// WEBPACK FOOTER //
// ./src/components/Search.js